import {
  Form,
  Row,
  Col,
  InputNumber,
  Input,
  Button,
  Table,
  Typography,
  Select,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";

const { Text } = Typography;

export default function CurrencySummary({
  form,
  currencyOptions,
  summaryEntries,
  setSummaryEntries,
}) {
  const handleAddSummary = () => {
    const values = form.getFieldsValue();
    const { currencySummary, shortage, overage, reason } = values;
    const selectedCurrency =
      currencyOptions.find((c) => c.value === currencySummary)?.label ??
      currencySummary;
    const hasShortage = Number(shortage) > 0;
    const hasOverage = Number(overage) > 0;

    if (!currencySummary || !reason) {
      BOM.AlertMsg(cnt.WARNING, "Currency and reason are required");
      return;
    }

    // if (hasShortage === hasOverage) {
    //   BOM.AlertMsg(
    //     cnt.WARNING,
    //     "Enter either a shortage or an overage for the currency",
    //   );
    //   return;
    // }

    const existingEntry = summaryEntries.find(
      (entry) => entry.currencySummary === selectedCurrency,
    );
    if (existingEntry) {
      BOM.AlertMsg(
        cnt.WARNING,
        `${selectedCurrency} already has a shortage or overage entry`,
      );
      return;
    }

    const newEntry = {
      key: Date.now(),
      currencySummary: selectedCurrency,
      shortage: hasShortage ? shortage : 0,
      overage: hasOverage ? overage : 0,
      reason: reason,
    };
    setSummaryEntries([...summaryEntries, newEntry]);
    form.setFieldsValue({
      currencySummary: undefined,
      shortage: undefined,
      overage: undefined,
      reason: undefined,
    });
  };

  const summaryColumns = [
    { title: "Currency", dataIndex: "currencySummary", key: "currencySummary" },
    { title: "Shortage", dataIndex: "shortage", key: "shortage" },
    { title: "Overage", dataIndex: "overage", key: "overage" },
    { title: "Reason", dataIndex: "reason", key: "reason" },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          type="text"
          className="of-primaryBtnColor"
          icon={<DeleteOutlined />}
          onClick={() =>
            setSummaryEntries(
              summaryEntries.filter((e) => e.key !== record.key),
            )
          }
        />
      ),
    },
  ];

  return (
    <>
      {/* <Divider /> */}
      <Form
        form={form}
        style={{ marginTop: 48 }}
        layout="vertical"
        onFinish={handleAddSummary}
      >
        <Row gutter={16} align="bottom" style={{ marginBottom: 12 }}>
          <Col span={6}>
            <Form.Item
              name="currencySummary"
              label={<Text strong>Currency</Text>}
              rules={[
                {
                  required: true,
                  message: "Currency is required",
                },
              ]}
            >
              <Select
                style={{ width: "100%", height: 44 }}
                options={currencyOptions}
                placeholder="Select currency"
                showSearch
                allowClear
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="shortage" label={<Text strong>Shortage</Text>}>
              <InputNumber
                style={{ width: "100%", height: 44, paddingTop: 6 }}
                min={0}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="overage" label={<Text strong>Overage</Text>}>
              <InputNumber
                style={{ width: "100%", height: 44, paddingTop: 6 }}
                min={0}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="reason"
              label={<Text strong>Reason</Text>}
              rules={[
                {
                  required: true,
                  message: "Reason is required",
                },
              ]}
            >
              <Input style={{ width: "100%", height: 44 }} />
            </Form.Item>
          </Col>
          <Col span={6}>
            {/* <Form.Item label=" "> */}
            <Button
              type="primary"
              className="of-primaryBtnColor"
              style={{ height: 44 }}
              onClick={handleAddSummary}
            >
              Add
            </Button>
            {/* </Form.Item> */}
          </Col>
        </Row>
      </Form>

      <Table
        style={{ marginTop: 16, marginBottom: 24 }}
        dataSource={summaryEntries}
        columns={summaryColumns}
        pagination={false}
        size="small"
      />
    </>
  );
}
